/*
 * Candles by Midnight — B2B enquiry → WhatsApp.
 * Validates required fields, composes a structured message, opens wa.me.
 */
if (!customElements.get('b2b-enquiry')) {
  customElements.define(
    'b2b-enquiry',
    class B2BEnquiry extends HTMLElement {
      connectedCallback() {
        this.wa = this.dataset.wa;
        this.error = this.querySelector('[data-error]');
        var btn = this.querySelector('[data-submit]');
        if (btn) btn.addEventListener('click', () => this.send());
        // prefill enquiry type if the page set one
        var v = (this.dataset.vertical || '').trim();
        if (v) {
          var sel = this.querySelector('[data-f="Enquiry"]');
          if (sel) {
            Array.from(sel.options).forEach(function (o) { if (o.text.toLowerCase().indexOf(v.toLowerCase()) > -1) o.selected = true; });
          }
        }
      }

      val(name) {
        var el = this.querySelector('[data-f="' + name + '"]');
        return el ? el.value.trim() : '';
      }

      send() {
        var name = this.val('Name'), company = this.val('Company'), email = this.val('Email');
        if (!name || !company || !email) {
          if (this.error) this.error.hidden = false;
          return;
        }
        if (this.error) this.error.hidden = true;

        var lines = [
          'New B2B enquiry — Candles by Midnight',
          '',
          'Name: ' + name,
          'Company: ' + company,
          'Email: ' + email,
        ];
        var phone = this.val('Phone'); if (phone) lines.push('Phone: ' + phone);
        lines.push('Enquiry type: ' + this.val('Enquiry'));
        lines.push('Quantity: ' + this.val('Quantity'));
        lines.push('Timeline: ' + this.val('Timeline'));
        var cust = this.val('Customisation'); if (cust) lines.push('Customisation: ' + cust);
        var notes = this.val('Notes'); if (notes) lines.push('Notes: ' + notes);

        var text = encodeURIComponent(lines.join('\n'));
        var url = this.wa ? ('https://wa.me/' + this.wa + '?text=' + text) : ('https://wa.me/?text=' + text);
        window.open(url, '_blank', 'noopener');
      }
    }
  );
}
